
const Menu = ( ( $ ) => {

  let windowWidth;
  const menu = document.querySelector( '.menu-outer-wrap' ),
        currentLangItem = document.querySelector('.wpml-ls-current-language'),
        burgerMenu = document.getElementById( 'burger-menu'  );

  const _calculateWidth = () => windowWidth = window.innerWidth;


  const _improveTabNavigation = function() {
    $('#site-navigation').find( 'a' ).on( 'focus blur', (function() {
      const $this = $(this);
      $this.parents( '.menu-item, .page_item' ).toggleClass( 'focus' );
      $this.parents( '.menu-item-has-children' ).attr( 'aria-expanded', $this.parents( '.menu-item-has-children' ).hasClass( 'focus' ) );
    }));
  };

  const _changeAriaAttribute = () => {
    const aria = burgerMenu.getAttribute( "aria-expanded" );
    let newAriaValue = ( aria === 'true' ) ? false : true;
    burgerMenu.setAttribute( "aria-expanded", newAriaValue );
  };

  const _toggleMobileMenu = () => {
    helpers.toggleClass( burgerMenu, 'is-open' );
    helpers.toggleClass( menu, 'is-active' );
    _changeAriaAttribute();
    return;
  };

  const _burgerEvent = () => {
    if ( windowWidth <= 1024 )
      burgerMenu.addEventListener( 'click', _toggleMobileMenu );
    else
      burgerMenu.removeEventListener( 'click', _toggleMobileMenu );
    return;
  };

  const _initializeEvents = helpers.debounce( () => {
    _calculateWidth();
    _burgerEvent();
  }, 500);

  const init = () => {
    _initializeEvents();
    _improveTabNavigation();
    window.addEventListener( "resize", _initializeEvents );
    $('.wpml-ls-current-language > a').on('click', (function(e) {
        e.preventDefault();
    }));

  };

  return {
    init: init
  };

})( jQuery );